import { combineReducers } from 'redux';

import attachments from './attachments';
import field from './field';
import fileId from './fileId';
import id from './id';
import isFetching from './isFetching';
import labelIds from './labelIds';
import originTitle from './originTitle';
import participant from './participant';
import pdfArrayBuffer from './pdfArrayBuffer';
import title from './title';
import url from './url';

export default combineReducers({
  attachments,
  field,
  fileId,
  id,
  isFetching,
  labelIds,
  participant,
  pdfArrayBuffer,
  originTitle,
  title,
  url,
});
